import script from "./InfoBox.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoBox.vue?vue&type=script&setup=true&lang=js"

import "./InfoBox.vue?vue&type=style&index=0&id=73c1b159&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c1b159"]])

export default __exports__